import React from 'react';
import { observer } from 'mobx-react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
  Tooltip,
  TextField,
  Divider,
} from '@mui/material';

import { useTranslation } from 'react-i18next';

const ORIENTATIONS = [
  { label: 'layouts.horizontal', value: 'Horizontal' },
  { label: 'layouts.vertical', value: 'Vertical' },
];
const TILES_PER_PAGE = [4, 6, 8, 10, 12, 14, 16];
const DURATIONS = [5, 10, 15, 30, 60];

const General = ({ state }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <TextField
        label={t('layouts.designName')}
        variant="outlined"
        fullWidth
        value={state.name}
        onChange={state.handleChange}
        name="name"
        className="mb-0"
      />
      <Divider />
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="demo-simple-select-outlined-label2">{t('layouts.tilesPerPage')}</InputLabel>
        <Tooltip
          placement="top"
          title={state.groupBy !== 'n/a' ? t('layouts.tilesPerPageNote') : ''}
        >
          <Select
            labelId="tiles-per-page"
            id="tiles-per-page"
            value={state.tilesPerPage}
            onChange={state.handleChange}
            label={t('layouts.tilesPerPage')}
            name="tilesPerPage"
          >
            {TILES_PER_PAGE.map((val, index) => (
              <MenuItem key={index} value={val}>
                {val}
              </MenuItem>
            ))}
          </Select>
        </Tooltip>
      </FormControl>
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="demo-simple-select-outlined-label2">{t('layouts.pageDuration')}</InputLabel>
        <Select
          labelId="pageDurationInSeconds"
          id="pageDurationInSeconds"
          value={state.pageDurationInSeconds}
          onChange={state.handleChange}
          label={t('layouts.pageDuration')}
          name="pageDurationInSeconds"
        >
          {DURATIONS.map((val, index) => (
            <MenuItem key={index} value={val}>
              {val} {t('layouts.seconds')}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="demo-simple-select-outlined-label2">
          {t('layouts.pageOrientation')}
        </InputLabel>
        <Select
          labelId="page-orientation"
          id="page-orientation"
          value={state.orientation}
          onChange={state.handleOrientationChange}
          label={t('layouts.pageOrientation')}
          name="orientation"
        >
          {ORIENTATIONS.map((item, index) => (
            <MenuItem key={index} value={item.value.toLowerCase()}>
              {t(item.label)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControlLabel
        disabled={state.orientation === 'horizontal'}
        control={
          <Tooltip title={t('config.tooltips.menuEditor')}>
            <Switch
              checked={state.orientation !== 'horizontal' && state.flipVertical}
              onChange={state.handleFlipVertical}
              disabled={state.orientation === 'horizontal'}
              name={t('layouts.rotateBy180degrees')}
              color="primary"
            />
          </Tooltip>
        }
        label={t('layouts.rotateBy180degrees')}
      />
    </Box>
  );
};

export default observer(General);
